
  import { COOKIE_LOAN_SEARCH, COOKIE_SELECTED_PRODUCT } from '@/constants/cookies';
  import { calculateLoan } from '@/scripts/loan';
  import { productToCookie } from '@/scripts/utils';
  import { mapGetters } from 'vuex';

  export default {
    data () {
      return {
        amount: 0,
        providerListExpanded: false,
        providerListLength: 5,
        selectedRate: 'ALL',
        sortDirection: 1,
        mounted: false
      };
    },
    computed: {
      ...mapGetters('products', { allLoans: 'getList' }),
      ...mapGetters('providers', { provider: 'get', providers: 'getList' }),
      ...mapGetters('search', { search: 'get' }),
      loans () {
        return this.allLoans
          .map(loan => calculateLoan(loan, this.search))
          .filter(loan => this.loanFilter(loan))
          .sort((a, b) => this.sortDirection * ((a.monthlyRepayment < b.monthlyRepayment) ? -1 : 1));
      },
      rateTypes () {
        const h = {};
        ['ALL', 'FIX', 'VAR'].forEach(f => {
          h[f] = this.$t(`results.rateType.${f}.label`);
        });
        return h;
      },
      termValues () {
        const h = {};
        [...Array(10).keys()].forEach(n => {
          h[n + 1] = this.$tc('year', n + 1);
        });
        return h;
      }
    },
    watch: {
      '$store.state.search.search.rate_type': function (newValue, oldValue) {
        this.setRateType(newValue);
      }
    },
    mounted () {
      if (this.search) {
        this.amount = this.search.amount;
        this.selectedRate = ['FIX', 'VAR'].includes(this.search.rate_type) ? this.search.rate_type : 'ALL';
      }
      this.mounted = true;
    },
    methods: {
      saveToCookies (loan) {
        this.$cookies.set(COOKIE_SELECTED_PRODUCT, productToCookie(loan));
      },
      loanFilter (loan) {
        if (!loan) {
          return false;
        }
        if (this.provider && (loan.institution.id !== this.provider.id)) {
          return false;
        }
        if (this.search.filtered_providers && this.search.filtered_providers.length > 0 && !this.search.filtered_providers.includes(loan.institution.slug)) {
          return false;
        }

        const loanTier = loan.loantiers.filter(tier => {
          const searchTerm = this.search.term * 12;
          const minterm = tier.minterm === null ? 0 : tier.minterm;
          const maxterm = tier.maxterm === null ? 0 : tier.maxterm;

          if (minterm <= searchTerm && maxterm >= searchTerm && tier.minamount <= this.search.amount && tier.maxamount >= this.search.amount) {
            return tier;
          }
        });

        if (loanTier.length === 0) return false;

        return this.search.rate_type === 'ALL' ? [0, '', null, loan.ratetype].includes(0) : [0, '', null, loan.ratetype].includes(this.search.rate_type);
      },
      loanPath (loan) {
        return this.localePath(`/compare-loans/${loan.institution.slug}/${loan.code}/${loan.slug}/`);
      },
      planFeatures (loan) {
        return loan.plan_features.filter(f => f.primary);
      },
      saveSearch () {
        if (this.mounted && this.search.id) {
          this.$api(`banking/loansearches/${this.search.id}`, { loansearch: this.search, method: 'put' }).then(r => {
            this.$store.commit('search/set', r);
            this.$cookies.set(COOKIE_LOAN_SEARCH, r);
          });
        }
      },
      setRateType (key) {
        if (this.selectedRate === key) {
          return;
        }
        this.selectedRate = key;
        this.$store.commit('search/set', {'rate_type': key});
      }
    }
  };
